import { cn } from '../lib/utils.js';

export const inputClassName =
  'flex h-(--control-height) w-full min-w-0 rounded-md border border-input bg-card px-3 py-1 text-base shadow-none transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-muted aria-invalid:border-destructive aria-invalid:ring-destructive/20 file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm';

/** @param {import('react').ComponentProps<'input'>} props */
export function Input({ className, type = 'text', ...props }) {
  return <input type={type} data-slot="input" className={cn(inputClassName, className)} {...props} />;
}

/** @param {import('react').ComponentProps<'textarea'>} props */
export function Textarea({ className, ...props }) {
  return <textarea data-slot="textarea" className={cn(inputClassName, 'h-auto min-h-20 py-2', className)} {...props} />;
}

/**
 * Native checkbox, styled. Accessible by default (label via <Label htmlFor>).
 * @param {Omit<import('react').ComponentProps<'input'>, 'type'>} props
 */
export function Checkbox({ className, ...props }) {
  return <input type="checkbox" data-slot="checkbox" className={cn('size-4 shrink-0 rounded border-input accent-primary', className)} {...props} />;
}
